import './associations-list.component.js';
import './associations-list.controller.js';
import './decline-association-modal.controller.js';
import './edit-association-modal.controller.js';
import './expire-association-modal.controller.js';



// WEBPACK FOOTER //
// ./components/collector/associations/list/index.js